import React from "react";
import { useNavigate } from "react-router-dom";
import { Search, Plus } from "lucide-react";
import { PageShell } from "@/components/Navbar";
import { Fade } from "@/components/proptech";
import { Button } from "@/components/ui/button";
import { VerificationBanner } from "@/components/VerificationBanner";
import { BuyerNeedsBrowser } from "@/components/BuyerNeedsBrowser";
import { Seo } from "@/components/Seo";
import { useAuth } from "@/context/AuthContext";

const BANNER_IMG = `${process.env.PUBLIC_URL || ""}/buyer-needs/bn-banner.webp`;

export default function BuyerNeeds() {
  const nav = useNavigate();
  const { user } = useAuth();
  const verifiedPro = user && (user.role === "ADMIN" || user.verification_status === "PROFESSIONAL_VERIFIED");
  return (
    <PageShell testid="buyer-needs-page">
      <Seo title="Buyer Needs · PropertyConnect" description="Browse active buyer needs across the PropertyConnect network and match them with your listings." noindex />
      <VerificationBanner />
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#EAF4FF] to-[#D6E9FA] border border-[#DCE5EF] px-5 sm:px-7 py-6 mb-6">
        <img src={BANNER_IMG} alt="" aria-hidden="true" className="pointer-events-none select-none absolute inset-0 w-full h-full object-cover" style={{ objectPosition: "right 32%" }} />
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#EAF4FF] via-[#EAF4FF]/90 to-[#EAF4FF]/55 sm:via-[#EAF4FF]/85 sm:to-[#EAF4FF]/10" />
        <div className="relative z-10 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
          <div className="min-w-0">
            <div className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-[#C6A04B] mb-2">
              <Search className="h-3.5 w-3.5" /> Buyer Needs
            </div>
            <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#17365D] leading-tight" data-testid="buyer-needs-title">Find Demand for Your Properties</h1>
            <p className="text-sm text-slate-600 mt-1.5 max-w-2xl">Explore active requirements for Buy, Rent, and Stays. Compare location, budget, must-haves, and timing—then respond with suitable inventory.</p>
          </div>
          {verifiedPro && (
            <Button data-testid="bn-post-header" onClick={() => nav("/have-buyer")}
              className="shrink-0 w-full sm:w-auto h-11 rounded-xl bg-[#C79A3B] hover:bg-[#C79A3B]/90 text-white font-semibold px-5">
              <Plus className="h-4 w-4 mr-1.5" /> Post Buyer Need
            </Button>
          )}
        </div>
      </div>
      <Fade><BuyerNeedsBrowser hidePostHeader panelBackdrop /></Fade>
    </PageShell>
  );
}
